import { TypographyType } from '@platform-ui-kit/components-library/dist/types/components/wpp-typography/types'
import { WppButton } from '@platform-ui-kit/components-library-react'
import { AnalyticsActionType, SourceLocations } from '@wpp-open/core'
import { useTranslation } from 'react-i18next'

import { BaseErrorState } from 'components/renderError/errorState/base/BaseErrorState'
import styles from 'components/renderError/errorState/osIsNotReady/OsIsNotReadyErrorState.module.scss'
import { SvgOsIsNotReady } from 'components/svg/renderError/SvgOsIsNotReady'
import { useAuth } from 'providers/auth/AuthContext'
import { trackAnalytics } from 'utils/analytics'

const OsIsNotReadyErrorState = () => {
  const { t } = useTranslation()
  const auth = useAuth()
  return (
    <BaseErrorState
      className={styles.container}
      illustration={<SvgOsIsNotReady />}
      mainTitle={t('os.error_state.os_is_not_ready.main_title')}
      subTitle={t('os.error_state.os_is_not_ready.sub_title')}
      description={t('os.error_state.os_is_not_ready.description')}
      mainTitleType={'2xl-heading' as TypographyType}
      actions={
        <>
          <WppButton
            className={styles.refreshButton}
            data-testid="reload-button"
            onClick={() => {
              window.location.reload()
            }}
          >
            {t('os.error_state.os_is_not_ready.primary_button')}
          </WppButton>

          {!!auth && (
            <WppButton
              variant="secondary"
              data-testid="logout-button"
              onClick={() => {
                trackAnalytics(
                  {
                    type: AnalyticsActionType.action,
                    payload: 'action_os_not_ready_logout',
                  },
                  SourceLocations.Core,
                )
                auth.logout()
              }}
            >
              {t('os.error_state.os_is_not_ready.secondary_button')}
            </WppButton>
          )}
        </>
      }
    />
  )
}

export default OsIsNotReadyErrorState
